import {
    Grid, Typography, Button, Snackbar, Alert, Box, Dialog, DialogActions,
    DialogContent, DialogTitle, TextField, FormControl, InputLabel, Select
} from "@mui/material";
import { Save as IconSave } from "@mui/icons-material";
import { PaperComponentDraggable } from "./PaperComponentDraggable";
import { useEffect, useState } from "react";
import * as direccionService from "../services/direccionService";
import UbigeoAutocomplete from "./common/UbigeoAutocomplete";

// Dialogo de mantenimiento de direccion: ubigeo unificado con autocompletado,
// detalle, referencia y estado.
const DireccionEdit = ({ open, openClose, entity, setNewSaved, isReadOnly }) => {
    const [idUbigeo, setIdUbigeo] = useState(0);
    const [ubigeoTexto, setUbigeoTexto] = useState("");
    const [detalle, setDetalle] = useState("");
    const [referencia, setReferencia] = useState("");
    const [idEstado, setIdEstado] = useState(2);

    const [enabledSave, setEnabledSave] = useState(true);
    const [openMessage, setOpenMessage] = useState(false);
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });

    const isEdicion = (entity?.id || 0) > 0;
    const isDialogReadOnly = isReadOnly || !enabledSave;
    const onCloseMessage = () => setOpenMessage(false);

    useEffect(() => {
        if (!open) return;
        setEnabledSave(true);
        setIdUbigeo(entity?.idUbigeo || 0);
        setUbigeoTexto(entity?.ubigeo || "");
        setDetalle(entity?.detalle || "");
        setReferencia(entity?.referencia || "");
        setIdEstado(entity?.idEstado ?? 2);
    }, [open, entity]);

    const advertir = (message) => {
        setPropsMessage({ severity: "error", message });
        setOpenMessage(true);
    };

    const postEntity = async () => {
        if (!idUbigeo) { advertir("Seleccione el ubigeo"); return; }
        if (!detalle || detalle.trim() === "") { advertir("El detalle es obligatorio"); return; }

        try {
            const dto = {
                idDireccion: entity?.id || 0, idUbigeo, detalle, referencia, idEstado
            };
            const id = isEdicion
                ? await direccionService.putDireccion(dto)
                : await direccionService.postDireccion(dto);
            if (id > 0) {
                setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" });
                setOpenMessage(true);
                setEnabledSave(false);
                if (setNewSaved) setNewSaved();
            } else {
                advertir("No se pudo guardar");
            }
        } catch (e) {
            advertir("Hubo un error");
        }
    };

    return (
        <Dialog open={open} onClose={openClose} fullWidth={true} maxWidth={"sm"} PaperComponent={PaperComponentDraggable}>
            <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
                <Typography variant="h5" component="span">
                    <Box sx={{ fontWeight: "bold" }}>
                        {(isEdicion ? "Editar " : "Registrar ") + "Direccion"}
                    </Box>
                </Typography>
            </DialogTitle>
            <DialogContent style={{ minHeight: "300px" }}>
                <div>
                    <Typography gutterBottom component="span">
                        <Box textAlign="center" padding={1}>
                            <Button variant="outlined" size="small" onClick={postEntity} disabled={isDialogReadOnly}>
                                Guardar
                                <IconSave />
                            </Button>
                        </Box>
                    </Typography>

                    <Grid container spacing={1.5}>
                        <Grid item xs={12}>
                            <UbigeoAutocomplete
                                label="Ubigeo / Distrito"
                                value={idUbigeo}
                                initialLabel={ubigeoTexto}
                                disabled={isDialogReadOnly}
                                required
                                onChange={(selected) => {
                                    setIdUbigeo(selected ? (selected.id || 0) : 0);
                                    setUbigeoTexto(selected ? selected.descripcion : "");
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Detalle"
                                value={detalle}
                                fullWidth
                                size="small"
                                required
                                onChange={(e) => setDetalle(e.target.value)}
                                disabled={isDialogReadOnly}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Referencia"
                                value={referencia}
                                fullWidth
                                size="small"
                                onChange={(e) => setReferencia(e.target.value)}
                                disabled={isDialogReadOnly}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth size="small" disabled={isDialogReadOnly}>
                                <InputLabel shrink>Estado</InputLabel>
                                <Select
                                    native
                                    size="small"
                                    value={idEstado}
                                    onChange={(e) => setIdEstado(parseInt(e.target.value))}
                                >
                                    <option value={2}>{"Activo"}</option>
                                    <option value={3}>{"Inactivo"}</option>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Typography component="span">
                        <Box textAlign="center" padding={1}>
                            <Button variant="outlined" size="small" onClick={postEntity} disabled={isDialogReadOnly}>
                                Guardar
                                <IconSave />
                            </Button>
                        </Box>
                    </Typography>

                    <Snackbar
                        open={openMessage}
                        autoHideDuration={5000}
                        onClose={onCloseMessage}
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    >
                        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                            {propsMessage.message}
                        </Alert>
                    </Snackbar>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={openClose}>Aceptar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DireccionEdit;
